import app from '@/app';

/* @ngInject */
function Resource($resource, $http, $q) {
	const resource = $resource(
		'api/plans/:id',
		{ id: '@id' },
		{
			create: { method: 'POST' },
			query: { method: 'GET' },
			update: { method: 'PUT' }
		}
	);

	resource.saveAllPlans = function(plans) {
		var eventSource = new EventSource('api/plans/planList'); // A URL do endpoint SSE

		// Enviar a lista de planos ao backend
		$http.post('api/plans/planList', plans).then(
			function() {
				eventSource.onmessage();
			}
		);
	};

	return resource;
}

app.factory('AllPlansByRoad', Resource);
